module.exports = {"610524001":"城关街道","610524101":"甘井镇","610524102":"坊镇","610524103":"洽川镇","610524104":"新池镇","610524105":"黑池镇","610524106":"路井镇","610524107":"和家庄镇","610524108":"王村镇","610524110":"同家庄镇","610524111":"百良镇","610524112":"金峪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610524.json
// module id = 2826
// module chunks = 0